import React, { useState, useEffect } from "react";
import {
  Input,
  Form,
  Col,
  Row,
  Button,
  Upload,
  notification,
  DatePicker,
  Select,
  Alert,
} from "antd";
import {
  PlusOutlined,
  MailFilled,
  UploadOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import RequestHandler from "util/RequestHandler";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import ScreenOptions from "../../util/Extensions/Screens";
import config from "../../util/ApiforContext";
import { odata } from "./../Filters/Helper";

const formItemLayout = {
  labelCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 8,
    },
  },
  wrapperCol: {
    xs: {
      span: 24,
    },
    md: {
      span: 24,
    },
    lg: {
      span: 12,
    },
  },
};

const ProjectStepNoteUpdateForm = (props) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    if (props.data) {
      form.setFieldsValue({
        id: props.data.id,
        note: props.data.note,
      });
    }
  }, [props.data]);
  const onSuccess = () => {
    form.resetFields();
    if (props.onSuccess) props.onSuccess();
  };

  const onFinish = (values) => {
    values.projectStepId = props.data.projectStepId;
    RequestHandler.put(`/ProjectStepNote`, values).then((response) => {
      setLoading(false);
      if (response.success) {
        onSuccess();
      }
    });
  };

  const onFinishFailed = (errorInfo) => {
    setLoading(false);
  };

  return (
    <Form
      {...formItemLayout}
      form={form}
      name="projectStepNoteUpdate"
      initialValues={{
        remember: true,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Row>
        <Col span={24}>
          <Form.Item name="id" hidden>
            {" "}
          </Form.Item>
          <Form.Item
            label="Not"
            name="note"
            rules={[
              {
                required: true,
                message: "Lütfen Açıklama alanını boş bırakmayın.",
              },
            ]}
          >
            <Input.TextArea rows={8} />
          </Form.Item>

          <Row justify="space-between">
            {/* <Col>
              <Button
                icon={<DownloadOutlined />}
                onClick={(() => setLoading(true), downloadExcelTemplate)}
                loading={loading}
              >
                Excel Şablonu İndir
              </Button>
              <Upload {...uploadExcelProps} fileList={fileList}>
                <Button icon={<UploadOutlined />}>Excel ile Ekle</Button>
              </Upload>
            </Col> */}
            <Col span={20}></Col>
            <Col span={4} style={{ textAlign: "right" }}>
              <Button
                type="primary"
                icon={<PlusOutlined />}
                htmlType="submit"
                onClick={() => setLoading(true)}
                loading={loading}
              >
                Güncelle
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </Form>
  );
};
export default ProjectStepNoteUpdateForm;
